module.exports = __webpack_public_path__ + "static/media/clock.d3845e47.svg";